import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, reactive, ref } from 'vue';
import DownFileList from "@/components/DownFileList/index.vue";
import Head from "@/components/Head/index.vue";
import { useRoute } from "vue-router";
import { useRouter } from "vue-router";
import useCurrentInstance from "@/hooks/useCurrentInstance";
export default defineComponent({
  name: 'LearningDatail',
  components: {
    Head: Head,
    DownFileList: DownFileList
  },
  setup: function setup() {
    var downFileLists = ref(null);

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var router = new useRouter();
    var route = new useRoute();
    var detail = reactive({
      list: {
        title: ''
      }
    });

    function backtrack() {
      router.push({
        name: 'learning'
      });
    }

    function create() {
      if (route.query.category == 1) {
        newDetails(route.query.id, "newDetails");
      } else {
        newDetails(route.query.id, "allDetails");
      }
    }

    create();

    function test(val) {
      console.log(1111111111111);
      console.log(val);
    }

    function test2(val) {
      console.log(1111111111111);
      console.log(val);
    } //详情


    function newDetails(_x, _x2) {
      return _newDetails.apply(this, arguments);
    } //下载附件列表


    function _newDetails() {
      _newDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, name) {
        var lis;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api[name](val);

              case 2:
                lis = _context.sent;

                if (lis.code == 0) {
                  detail.list = lis.data;
                  console.log(lis);

                  if (lis.data.attachmentId) {
                    console.log("一次");
                    download({
                      ids: lis.data.attachmentId
                    });
                  }
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _newDetails.apply(this, arguments);
    }

    function download(_x3) {
      return _download.apply(this, arguments);
    }

    function _download() {
      _download = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(val) {
        var lis, dat, ids;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["download"](val);

              case 2:
                lis = _context2.sent;

                if (lis.code == 0) {
                  dat = [];
                  dat = lis.data;
                  ids = String(dat[0].attachmentId);
                  console.log(ids);
                  dat.forEach(function (item, index) {
                    if (index != 0) {
                      ids = ids + "," + String(item.attachmentId);
                    }
                  });
                  downFileLists.value && downFileLists.value["showList"]({
                    type: "ids",
                    value: ids
                  });
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _download.apply(this, arguments);
    }

    return {
      route: route,
      newDetails: newDetails,
      create: create,
      detail: detail,
      backtrack: backtrack,
      downFileLists: downFileLists,
      test: test,
      test2: test2
    };
  }
});